module.exports = __webpack_public_path__ + "assets/img/Frame.54d8a72e.svg";